module.exports = __webpack_public_path__ + "static/img/add.8337ed7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lite/icon/add.svg
// module id = LDFH
// module chunks = 2